import React from 'react';
import { Link } from 'react-router-dom';
import { styled, css, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { imgLinks } from '../../shared';

const baseStyle = ({ theme, disabled }) => css`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0 0 1.5rem;
  width: fit-content;
  font-size: 1.25rem;
  font-weight: 700;
  color: ${theme.palette.main.professional_blue};
  text-decoration: none;
  cursor: pointer;

  &:focus {
    box-shadow: none;
  }

  > img {
    margin-right: 0.5rem;
  }

  ${disabled &&
  css`
    opacity: 0.5;
    pointer-events: none;
  `}
`;

const StyledButton = styled('button')`
  ${baseStyle}
`;
const StyledLink = styled(Link)`
  ${baseStyle}
`;
const StyledHref = styled('a')`
  ${baseStyle}
`;

function BackButton(props) {
  const { label, to, href, target, onClick, ...rest } = props;

  const intl = useIntl();

  const displayText =
    label ||
    intl.formatMessage({
      id: 'common.button.back',
    });

  if (onClick) {
    return (
      <StyledButton onClick={onClick} {...rest}>
        <img src={imgLinks['icon.back.arrow']} alt="back" />

        <Typography variant="h3">{displayText}</Typography>
      </StyledButton>
    );
  }

  if (to) {
    return (
      <StyledLink to={to} {...rest}>
        <img src={imgLinks['icon.back.arrow']} alt="back" />

        <Typography variant="h3">{displayText}</Typography>
      </StyledLink>
    );
  }

  if (href) {
    return (
      <StyledHref href={href} target={target} {...rest}>
        <img src={imgLinks['icon.back.arrow']} alt="back" />

        <Typography variant="h3">{displayText}</Typography>
      </StyledHref>
    );
  }

  return null;
}

export default BackButton;

BackButton.defaultProps = {
  'data-testid': 'back-button',
};

BackButton.propTypes = {
  'to': PropTypes.string,
  'href': PropTypes.string,
  'target': PropTypes.string,
  'onClick': PropTypes.func,
  'data-testid': PropTypes.string,
};
